// PostgREST returns at most 1,000 rows unless the caller pages with .range().
// Shared helper so org-scoped workbench reads walk every page instead of
// silently stopping at the first chunk.

export const POSTGREST_MAX_ROWS = 1000;

export interface OrgScopedQueryResult<T = unknown> {
  data: T[] | null;
  error: { message: string } | null;
}

export interface OrgScopedSelectBuilder {
  eq(column: string, value: unknown): OrgScopedSelectBuilder;
  order(column: string, options?: { ascending?: boolean }): OrgScopedSelectBuilder;
  range(from: number, to: number): Promise<OrgScopedQueryResult>;
}

export interface PagedOrgClient {
  from(table: string): {
    select(columns: string): OrgScopedSelectBuilder;
  };
}

export async function fetchAllOrgScopedRows<T>(
  client: PagedOrgClient,
  table: string,
  columns: string,
  organisationId: string,
  pageSize = POSTGREST_MAX_ROWS,
  orderColumn = 'id',
): Promise<OrgScopedQueryResult<T>> {
  const all: T[] = [];
  let from = 0;

  for (;;) {
    const result = await client
      .from(table)
      .select(columns)
      .eq('organisation_id', organisationId)
      .order(orderColumn, { ascending: true })
      .range(from, from + pageSize - 1);

    if (result.error) {
      return { data: null, error: result.error };
    }

    const page = (result.data ?? []) as T[];
    all.push(...page);
    if (page.length < pageSize) {
      return { data: all, error: null };
    }
    from += pageSize;
  }
}
